import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex cos-both-form-item" }

import { onMounted, ref } from 'vue'
import { message } from '@dc-platform/dc-components'
import dataConfig from '@/views/overseasSales/commonEnum/dataConfig'
import { customerContactAdd, customerContactEdit } from '@/api/overseasSales/customerCenter'
import type { PotentialItem } from '@/typings/api/customerCenter'
import { ofbuContactValidate, concatNameValidate } from '@/utils/validate'
import { listByParamCodes } from '@/api/common'
import { cloneDeep } from 'lodash-es'
import { useI18n } from 'vue-i18n'

const __default__ = {
  name: 'ContactsModal'
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  contactRefId: {
    type: String
  }
},
  emits: ['success'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t } = useI18n()
const formRef = ref()
const loading = ref(false)
const visible = ref(false)
const form = ref<PotentialItem['contact']>({})
const paramCodeData = ref<{
  fbu_area_code: []
}>({
  fbu_area_code: [] // 电话区号
})
const emit = __emit
const props = __props
onMounted(() => {
  getByParamCodes()
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: ['ofbu_area_code']
  }).then((res) => {
    if (res.code === 200) {
      paramCodeData.value = res.data
    }
  })
}
const success = (type: 'add' | 'edit') => {
  emit('success', type)
}
const toggle = (row: PotentialItem['contact']) => {
  console.log(row)
  form.value = row ? cloneDeep(row) : {}
  visible.value = true
}
// 新增编辑提交
const handleSubmit = () => {
  formRef.value.validate().then(async () => {
    loading.value = true
    try {
      if (form.value?.id) {
        await customerContactEdit(form.value)
        message.success(t('tips.editSuccess'))
        success('edit')
      } else {
        await customerContactAdd({
          ...form.value,
          contactRefId: props.contactRefId
        })
        message.success(t('tips.addSuccess'))
        success('add')
      }
      loading.value = false
      visible.value = false
    } catch (error) {
      loading.value = false
    }
  })
}
__expose({
  toggle
})

return (_ctx: any,_cache: any) => {
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((visible).value = $event)),
    title: form.value.id ? _unref(t)('common.editConcatModalTitle') : _unref(t)('common.addConcatModalTitle'),
    width: "900px",
    onOk: handleSubmit,
    confirmLoading: loading.value
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createBlock(_component_a_form, {
            key: 0,
            model: form.value,
            ref_key: "formRef",
            ref: formRef
          }, {
            default: _withCtx(() => [
              _createVNode(_component_dc_layout_card, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_a_form_item, {
                          span: 24,
                          label: _unref(t)('common.firstName'),
                          style: {"width":"50%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CosInput, {
                              value: form.value.firstName,
                              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.firstName) = $event)),
                              maxlength: 50
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_a_form_item, {
                          label: _unref(t)('common.lastName'),
                          name: "lastName",
                          style: {"width":"50%"},
                          class: "last-compact",
                          rules: [
                {
                  message: _unref(t)('common.pleaseInput'),
                  required: true
                },
                {
                  validator: _unref(concatNameValidate)
                }
              ]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CosInput, {
                              value: form.value.lastName,
                              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((form.value.lastName) = $event)),
                              maxlength: 50
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }, 8, ["label", "rules"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('common.mobile'),
                    class: "form-item_compact"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_group, { compact: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ParamCodesSelect, {
                            options: paramCodeData.value.ofbu_area_code,
                            value: form.value.mobileRegion,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.value.mobileRegion) = $event)),
                            style: {"width":"33%"}
                          }, null, 8, ["options", "value"]),
                          _createVNode(_component_a_form_item, {
                            style: {"width":"67%"},
                            class: "last-compact",
                            name: "mobile",
                            rules: {
                validator: (rule, value) => _unref(ofbuContactValidate)(rule, value, form.value, formRef.value)
              }
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CosInput, {
                                value: form.value.mobile,
                                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((form.value.mobile) = $event)),
                                placeholder: _unref(t)('tips.AJpVtAl4')
                              }, null, 8, ["value", "placeholder"])
                            ]),
                            _: 1
                          }, 8, ["rules"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    name: "skype",
                    label: _unref(t)('common.skype'),
                    rules: {
            validator: (rule, value) => _unref(ofbuContactValidate)(rule, value, form.value, formRef.value)
          }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.skype,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((form.value.skype) = $event)),
                        placeholder: _unref(t)('tips.AJpVtAl4'),
                        maxlength: 50
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label", "rules"]),
                  _createVNode(_component_dc_form_item, {
                    name: "email",
                    label: _unref(t)('common.email'),
                    rules: [
            {
              validator: (rule, value) => _unref(ofbuContactValidate)(rule, value, form.value, formRef.value)
            }
          ]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.email,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((form.value.email) = $event)),
                        placeholder: _unref(t)('tips.AJpVtAl4')
                      }, null, 8, ["value", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label", "rules"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('common.sex')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosSelect, {
                        value: form.value.sex,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((form.value.sex) = $event)),
                        options: _unref(dataConfig).genderEnum,
                        "allow-clear": ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('common.jobRole')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosSelect, {
                        value: form.value.jobRole,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((form.value.jobRole) = $event)),
                        options: _unref(dataConfig).linkRoleTypeEnum,
                        "allow-clear": ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('common.jobDuty')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.jobDuty,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((form.value.jobDuty) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('common.remark'),
                    span: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosTextarea, {
                        value: form.value.remark,
                        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((form.value.remark) = $event)),
                        maxlength: 2000
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "title", "confirmLoading"]))
}
}

})